// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".add-travel-information-button,\n.ant-btn:hover {\n  border-color: unset;\n}\n.add-travel-information-button,\n.ant-btn:active {\n  border-color: unset;\n}\n", ""]);
// Exports
module.exports = exports;
